export default function ProjectCardLoader() {
    return (
        <>
            <div className="card mt-3 pt-2 pb-3 shadow placeholder-glow p-3 fadeIn " >
                <ul style={{ listStyle: "none" }} className="p-3">

                    <div className="row mb-2 mt-3" >

                        <li className="placeholder placeholder-xs col-6 ms-2" ></li>
                        <li className="col-3"></li>
                        <li className="placeholder placeholder-xs col-2 mb-1" ></li>
                    </div>
                    <li className="placeholder placeholder-xs col-3 mb-1" ></li>
                    <br />
                    <li className="placeholder placeholder-xs col-12 mb-2" ></li>
                    <div className="placeholder w-100" ></div>
                </ul>
            </div>
        </>
    )
}

